import {
  ProcessInteractiveFlowchart,
  ProcessFlowchartInteractiveNode,
} from 'processes/graph-builder-processes/flowchart-viz/ProcessFlowchartVizConstants';
import {
  isRootNode,
  isTaskNode,
} from 'processes/graph-builder-processes/flowchart-viz/util/getNodeDetailsTypeForInteractiveNode';
import findFirstMatchingNodeAlongEveryPath from 'util/graph-utils/findFirstMatchingNodeAlongEveryPath';
import {AdjacencyMap} from 'util/graph-utils/GraphUtilConstants';

import {ProcessFlowchartRootNode, ProcessFlowchartTaskNode} from '../ProcessFlowchartNodeDetailType';

export default function findUpstreamTaskNodes(
  sourceNode: ProcessFlowchartInteractiveNode,
  flowchart: ProcessInteractiveFlowchart
): Array<ProcessFlowchartTaskNode | ProcessFlowchartRootNode> {
  const invertedAdjacencyMap: AdjacencyMap = {};
  const nodeById: Record<string, ProcessFlowchartInteractiveNode> = {};
  for (const node of flowchart.nodes) {
    invertedAdjacencyMap[node.clientId] = [];
    nodeById[node.clientId] = node;
  }
  for (const edge of flowchart.edges) {
    if (invertedAdjacencyMap[edge.toNodeClientId] == null) {
      invertedAdjacencyMap[edge.toNodeClientId] = [];
    }
    invertedAdjacencyMap[edge.toNodeClientId].push(edge.fromNodeClientId);
  }
  return findFirstMatchingNodeAlongEveryPath(
    sourceNode.clientId,
    invertedAdjacencyMap,
    (nodeId) => isTaskNode(nodeById[nodeId]) || isRootNode(nodeById[nodeId])
  ).map(({nodeId}) => nodeById[nodeId]) as Array<ProcessFlowchartTaskNode>;
}
